<!--@Deprecated use /decisioning-criteria/components/CriterionInputComponents/...-->
<template>
    <div class="CriterionTextInput">
        <FormElement :label="hideTitle ? null : schema.title">
            <template v-if="schema.description" #labelHint>
                <div
                    v-tooltip="schema.description"
                    class="CriterionEnumInput__hintIcon"
                >
                    <FontAwesomeIcon :icon="faQuestionCircle" />
                </div>
            </template>
            <FormInput :invalid="showValidationErrors && (showError || accessed) && hasError" force-error-slot>
                <input
                    type="text"
                    :value="value"
                    :maxlength="schema.maxLength || 1024"
                    :disabled="rbacDisabled"
                    @input="onInput"
                    @blur="touch"
                    @focus="onFocus"
                    @change="onChange"
                >
                <template v-if="showValidationErrors && (showError || accessed) && hasError" #errorMessage>
                    {{ errorMessage }}
                </template>
                <template v-if="deletable || rbacDisabled" #actionButtons>
                    <LockInputIcon v-if="rbacDisabled" />
                    <NewButton
                        v-else-if="deletable"
                        variant="flat"
                        size="icon-sm"
                        color="secondary"
                        class="JsonSchemaForm__deleteIcon"
                        @click="$emit('delete')"
                    >
                        <EidIcon :icon-src="faXmark" alt="delete" />
                    </NewButton>
                </template>
            </FormInput>
        </FormElement>
    </div>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
    import { faXmark } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import LockInputIcon from '@evidentid/dashboard-commons/components/LockInputIcon/LockInputIcon.vue';
    import { JsonSchemaString } from '@evidentid/json-schema/interfaces/JsonSchema';

    import NewButton from '@/components/new-button/NewButton.vue';

    import AbstractCriterionInput from './AbstractCriterionInput';

    @Component({
        emits: [ 'change', 'delete', 'input' ],
        components: { EidIcon, FormInput, FontAwesomeIcon, FormElement, LockInputIcon, NewButton },
    })
    export default class CriterionTextInput extends AbstractCriterionInput<JsonSchemaString, string> {
        // @Deprecated use /decisioning-criteria/components/CriterionInputComponents/...
        private faXmark = faXmark;
        private faQuestionCircle = faQuestionCircle;

        private onInput(event: InputEvent) {
            const inputValue = (event.target as HTMLInputElement).value;
            this.$emit('input', inputValue);
        }

        private onChange(event: Event): void {
            const inputValue = (event.target as HTMLInputElement).value;
            this.$emit('change', inputValue);
        }

        private beforeMount() {
            this.setSchemaVisible?.(this.schemaPath, true);
        }

        private beforeDelete() {
            this.setSchemaVisible?.(this.schemaPath, false);
        }
    }
</script>
